import React from "react";
import { Container, Row } from "react-bootstrap";
import HomeButton from "./components/HomeButton.js";
import ModuleOverview from "./components/ModuleOverview.js";
import "../TrainingPages.css";
import Metadata from "./components/Metadata.js";
import ModuleLinks from "./components/ModuleLinks.js";

function SplashPage(props) {
    /**
     * Splash page component. Takes all imported sub-components and creates the full HTML page.
     * @param props: master JSON object with training information to populate the page with (one child per JSON property)
     * @returns: splash page JSX containing home button, module overview, and metadata/links
     */

    // When splash page renders, add the training title to the document title that shows up in browser tab
    document.title = `${document.title} - ${props.module["title"]}`;

    return (
        <div className="bg-image-sport body-sport">
            <Container className="pt-2">
                <HomeButton/>
                <ModuleOverview title={props.module["title"]} date={props.module["date"]} thumbnail={props.module["thumbnail"]} text={props.module["text"]}/>
                <Row>
                    <Metadata metadata={props.module["metadata"]}/>
                    <ModuleLinks moduleLinks={props.module["module_links"]}/>
                </Row>
            </Container>
        </div>
    );
}

export default SplashPage;